var map = {
	"./czekam-na-ciebie.pdf": 8104,
	"./in-christ-alone.pdf": 7834,
	"./moim-pokojem.pdf": 6298,
	"./naleze-do-ciebie.pdf": 6832,
	"./nie-patrze-wstecz.pdf": 766,
	"./no-longer-slaves.pdf": 5664,
	"./pelen-laski.pdf": 3734,
	"./prosze-powiedz-panie.pdf": 7356,
	"./selah.pdf": 3270,
	"./spiewam-chwala.pdf": 8029,
	"./ufac-bede.pdf": 3752,
	"./wszystkie-moje-mysli.pdf": 2321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2289;